import { SIGNUP_URL } from "@/constants/links";

export default function FinalCta({ onOpenDemo }) {
    return (
        <section className="final-cta" data-testid="v2-final-cta">
            <div className="container final-cta__inner">
                <h2 className="final-cta__title reveal">
                    Know your numbers. Every single morning.
                </h2>
                <p className="final-cta__sub reveal">
                    The first thing successful businesses check each morning
                    isn't email.
                    <br />
                    It's C-ORE.
                </p>
                <div className="final-cta__actions reveal">
                    <a
                        className="btn btn--gradient btn--lg"
                        href={SIGNUP_URL}
                        data-testid="v2-final-cta-trial"
                    >
                        Start free trial
                    </a>
                    <button
                        type="button"
                        className="btn btn--secondary btn--lg"
                        onClick={onOpenDemo}
                        data-testid="v2-final-cta-demo"
                    >
                        See demo
                    </button>
                </div>
            </div>
        </section>
    );
}
